import { UPDATE_FRIENDS_VIEW } from './types';


export function FriendsViewReducer(state, action) {

    const { payload, type } = action


    switch (type) {

        case UPDATE_FRIENDS_VIEW:
            return {
                ...state,
                friendsViewData: payload
            }
        default:
            break;
    }

} 